import React, { useState } from 'react'
import SubHeader from '../general/SubHeader';
import axios from 'axios';
import RateUs from '../assets/rateus.jpeg';

const Contact = () => {
    const [responseMessage, setResponseMessage] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponseMessage(''); // Clear previous response message

        try {
            const response = await axios.post('https://apis.anvifoundation.com/omanshi/contact', formData);

            if (response.status === 200) {
                setResponseMessage('Thank you for getting in touch! We will respond to you soon.');

                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
            }
        } catch (error) {
            // Handle error response
            setResponseMessage('Error submitting form. Please try again later.');
            setTimeout(() => {
                setResponseMessage('');
            }, 3000);
        }
    };


    return (
        <>
            <SubHeader message="Contact" />

            {/* contact section */}
            <section className='py-5 bg-light'>
                <div className='container px-lg-5 px-4'>

                    <div className='row mb-4'>

                        <p className='sec-subheading'>Enquire Now</p>
                        <p className='sec-heading'>Get in Touch with Us</p>
                        <div className='col-lg-8 col-12 my-2'>


                            <form class="row g-2 bg-white py-4 px-3" onSubmit={handleSubmit}>
                                <div class="my-2 col-12">
                                    <input type="text" class="form-input" value={formData.name} name='name' onChange={handleChange} placeholder='Your Name' required />
                                </div>
                                <div class="my-2 col-md-6">
                                    <input type="tel" class="form-input" value={formData.phone} name='phone' onChange={handleChange} placeholder='Your Phone' required />
                                </div>
                                <div class="my-2 col-md-6">
                                    <input type="email" class="form-input" value={formData.email} name='email' onChange={handleChange} placeholder='Your Email' required />
                                </div>
                                <div className='my-2 col-12'>
                                    <textarea type="text" className="form-input" value={formData.message} name='message' onChange={handleChange} placeholder='Message' style={{ height: '10em' }}></textarea>
                                </div>

                                <div class="col-12">
                                    <button type="submit" class="slider-btn w-100">Send Message</button>
                                </div>
                            </form>
                        </div>


                        <div className='col-lg-4 col-md-6 col-12'>
                            <div className='bg-white h-100 py-2'>
                            <p className='sec-subheading px-3 my-0'>Enjoyed Tour? Rate Us!</p>
                            <img src={RateUs} onClick={() => window.open('https://maps.app.goo.gl/D3kcD8DUiMa9ig9r8', '_blank')}
                            className='img-fluid cursor-pointer' />
                            </div>
                        </div>

                    </div>
                    {/* row ends */}

                    <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3602.0098904659712!2d81.85650780000002!3d25.4713452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acb17223bff9d%3A0xd1dc20eda92b7861!2sOmanshi%20travels!5e0!3m2!1sen!2sin!4v1736414492781!5m2!1sen!2sin"
                        className='w-100' height="450" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                </div>
            </section>
            {/* contact section ends */}

            {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}><i class="fa-solid fa-xmark"></i></p>
                </div>)}


        </>
    )
}

export default Contact
